import Vue from "vue";
import moment from "moment";
import find from "lodash/find";
import cloneDeep from "lodash/cloneDeep";
import GENDERS from "@/assets/tables/genders.json";
import REGIONS from "@/assets/tables/regions.json";
import PLANS from "@/assets/tables/plans.json";
import RECEIPT_TYPES from "@/assets/tables/receipt_types.json";

Vue.filter("genderFilter", v => {
  return v ? find(GENDERS, o => o.value === v).text : "";
});

Vue.filter("regionFilter", v => {
  return v ? find(REGIONS, o => o.value === v).text : "";
});

Vue.filter("planFilter", v => {
  return v ? find(PLANS, o => o.value === v).text : "";
});

Vue.filter("receiptTypeFilter", v => {
  return v ? find(RECEIPT_TYPES, o => o.value === v).text : "";
});

Vue.filter("timestampFilter", v => {
  return v ? moment(v.toDate()).format("YYYY/MM/DD") : "-";
});

Vue.filter("receiptItemFilter", item => {
  if (!item) return "-";

  let type = RECEIPT_TYPES[item.type].value;

  switch (type) {
    case "donation":
      type = item.donation ? `樂捐-${item.donation}` : "樂捐";
      break;
    case "other":
      type = `其他-${item.other}`;
      break;
    default:
      type = RECEIPT_TYPES[item.type].text;
  }

  const { payment } = item;
  return `${type} ${payment}`;
});

Vue.filter("lastReceiptDetailFilter", lastReceipt => {
  if (!lastReceipt) return "";

  const type =
    lastReceipt.type === "other"
      ? lastReceipt.other
      : RECEIPT_TYPES[lastReceipt.type].text;

  const { amount } = lastReceipt;
  return `${type} ${amount}`;
});

Vue.filter("boolean", v => {
  return v ? "是" : "否";
});

Vue.filter("clone", value => {
  return cloneDeep(value);
});
